// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-pdp-style.liquid (scripts 7, 10, 11 and 9) so the browser can cache it. Code unchanged.
  /* 7. drop the " from" text node between was-price and price, now and after every variant change */
  (function () {
    function strip() {
      document.querySelectorAll('.product-page-info .price--sale, .footbar-product .price--sale').forEach(function (p) {
        [].slice.call(p.childNodes).forEach(function (n) { if (n.nodeType === 3 && /\S/.test(n.nodeValue)) p.removeChild(n); });
      });
    }
    function start() {
      strip();
      var box = document.querySelector('.product-page-info') || document.body;
      new MutationObserver(function () { strip(); }).observe(box, { childList: true, subtree: true, characterData: true });
      /* 10. payment icons straight after the Add to cart form ("More payment options" is the form's last line) */
      var pay = box.querySelector('.product-page-info__payments'), atc = box.querySelector('[data-js-product-button-add-to-cart]');
      var form = atc && atc.closest('.form');
      if (pay && form && form.parentNode === pay.parentNode) { pay.classList.add('adore-moved'); form.parentNode.insertBefore(pay, form.nextSibling); }
      /* 11. 27 Sep 2026 (Yass): the Judge.me review list moves up to sit before the description tabs (it rendered in its
         own app section under related products). Polls briefly because Judge.me sets the widget up after load. */
      var tries = 0;
      (function moveReviews() {
        var rev = document.querySelector('.jdgm-widget.jdgm-review-widget'), tabs = document.querySelector('.product-page__tabs');
        if (rev && tabs) { var holder = document.createElement('div'); holder.className = 'adore-reviews-up mt-30'; holder.appendChild(rev); tabs.parentNode.insertBefore(holder, tabs); return; }
        if (++tries < 40) setTimeout(moveReviews, 250);
      })();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  /* 9. 27 Sep 2026 (Yass): zoom on the photo on phones. Tapping a photo opens the theme's full-screen viewer, which had no
     way to zoom on a touch screen. Now: pinch to zoom (up to 4x), double-tap to zoom in or out, drag to move around while
     zoomed, and the viewer loads a 1600px copy of the photo the first time it is zoomed. Desktop hover zoom is untouched. */
  (function () {
    function start() {
      if (!('ontouchstart' in window)) return;
      var fs = document.querySelector('[data-js-product-gallery-fullscreen]');
      if (!fs) { if ((start.tries = (start.tries || 0) + 1) < 20) setTimeout(start, 500); return; }
      var img = null, scale = 1, tx = 0, ty = 0, startDist = 0, startScale = 1, lastTap = 0, panning = false, px = 0, py = 0, stx = 0, sty = 0, pinching = false;
      function cur() { var s = fs.querySelector('.slick-current'); return s ? s.querySelector('img') : null; }
      function hires() {
        if (!img || img.__adoreHi) return; img.__adoreHi = true;
        var m = img.getAttribute('data-master'); if (m) { img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.src = m.replace('{width}', '1600'); }
      }
      function apply() {
        if (!img) return;
        img.style.transition = 'none'; img.style.transformOrigin = 'center center';
        img.style.transform = scale > 1 ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')' : '';
        if (scale > 1) hires();
      }
      function reset() { if (img) { img.style.transform = ''; } scale = 1; tx = 0; ty = 0; panning = false; pinching = false; }
      function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
      fs.addEventListener('touchstart', function (e) {
        var i = cur(); if (!i) return; if (img !== i) { reset(); img = i; }
        if (e.touches.length === 2) { pinching = true; startDist = dist(e.touches); startScale = scale; e.stopPropagation(); return; }
        if (e.touches.length !== 1) return;
        var now = Date.now();
        if (now - lastTap < 300) {
          lastTap = 0;
          if (scale > 1) { scale = 1; tx = 0; ty = 0; }
          else { scale = 2.5; var r = img.getBoundingClientRect(); var cx = e.touches[0].clientX - (r.left + r.width / 2), cy = e.touches[0].clientY - (r.top + r.height / 2); tx = -cx * (scale - 1); ty = -cy * (scale - 1); }
          apply(); e.preventDefault(); e.stopPropagation(); return;
        }
        lastTap = now;
        if (scale > 1) { panning = true; px = e.touches[0].clientX; py = e.touches[0].clientY; stx = tx; sty = ty; e.stopPropagation(); }
      }, { capture: true, passive: false });
      fs.addEventListener('touchmove', function (e) {
        if (!img) return;
        if (pinching && e.touches.length === 2) { scale = Math.min(4, Math.max(1, startScale * dist(e.touches) / startDist)); apply(); e.preventDefault(); e.stopPropagation(); return; }
        if (panning && e.touches.length === 1) { tx = stx + (e.touches[0].clientX - px); ty = sty + (e.touches[0].clientY - py); apply(); e.preventDefault(); e.stopPropagation(); }
      }, { capture: true, passive: false });
      fs.addEventListener('touchend', function (e) {
        if (pinching && e.touches.length < 2) { pinching = false; if (scale <= 1.05) { scale = 1; tx = 0; ty = 0; apply(); } else if (e.touches.length === 1) { panning = true; px = e.touches[0].clientX; py = e.touches[0].clientY; stx = tx; sty = ty; } e.stopPropagation(); return; }
        if (panning && e.touches.length === 0) { panning = false; e.stopPropagation(); }
      }, { capture: true });
      /* zoom resets when the viewer closes or the photo changes */
      new MutationObserver(function () { if (!fs.classList.contains('show')) reset(); }).observe(fs, { attributes: true, attributeFilter: ['class'] });
      fs.addEventListener('click', function (e) { if (e.target.closest('[data-js-product-gallery-fullscreen-arrow-prev],[data-js-product-gallery-fullscreen-arrow-next]')) reset(); }, true);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

